import React from 'react';
import s from './SalonFilter.module.scss';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const customStyles = {
  control: provided => ({
    ...provided,
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
    },
    background: 'none',
  }),
};

const Selector = ({ name, options, placeholder, onChange, value }: any) => {

  const {t} = useTranslation() as any
  return (
    <div className={s.selector}>
      <div className={s.selector_left}>{t(name)}</div>
      <div className={s.selector_right}>
        <Select
          options={options}
          styles={customStyles}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
      </div>
    </div>
  );
};

export default Selector;
